module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-left-bottom-metals-remnants.a373bb2b.png";